import { render, staticRenderFns } from "./UploadPanel.vue?vue&type=template&id=5bd380dd&scoped=true&"
import script from "./UploadPanel.vue?vue&type=script&lang=js&"
export * from "./UploadPanel.vue?vue&type=script&lang=js&"
import style0 from "./UploadPanel.vue?vue&type=style&index=0&id=5bd380dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd380dd",
  null
  
)

export default component.exports